import {
  SHOW_API_ERROR,
  CLEAR_API_ERROR,
  SET_API_ERROR_MSG_CONFIG,
} from '../../constants/reducerTypes';
import { ApiErrorMsgConfig } from '../../app_config/apiConfig';

const initialState = { showError: false, message: '', errorMesgConfig: ApiErrorMsgConfig };

const errorReducer = (state = initialState, action) => {
  switch (action.type) {
    case SHOW_API_ERROR:
      return {
        ...state,
        showError: true,
        message: action.payload,
      };
    case CLEAR_API_ERROR:
      return {
        ...state,
        showError: false,
        message: '',
      };
    case SET_API_ERROR_MSG_CONFIG:
      return {
        ...state,
        errorMesgConfig: {
          ...state.errorMesgConfig, 
          ...(action.payload || {}),
        },
      };
    default:
      return state;
  }
};
export default errorReducer;
